import { createSlice } from '@reduxjs/toolkit';

export interface FormsState {
  forms: Record<string, boolean>;
}

const initialState: FormsState = { forms: {} };

const slice = createSlice({
  name: 'forms',
  initialState,
  reducers: {
    // Update or add a form's dirty state
    updateFormDirtyState: (state, action) => {
      const { formId, isDirty } = action.payload;
      state.forms[formId] = isDirty;
    },
    // Remove a specific form from the state
    removeFormState: (state, action) => {
      const { formId } = action.payload;
      delete state.forms[formId];
    },
    // Reset all forms in the state
    resetAllFormStates: (state) => {
      state.forms = {};
    },
  },
});

export const { updateFormDirtyState, removeFormState, resetAllFormStates } = slice.actions;

export default slice.reducer;
